import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import MarsLogo from "../../../../assets/img/Mars_icon_white.png";
import MarsLogo1 from "../../../../assets/img/pdfLogo.png";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 30,
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  page1: {
    flexDirection: "column",
    padding: 10,
    backgroundColor: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: 10,
  },

  // Header styles
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    paddingBottom: 10,
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    borderBottomColor: "#2563eb",
  },

  logoSection: {
    flexDirection: "column",
  },

  logoText: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#1e40af",
  },

  logoSubtext: {
    fontSize: 10,
    color: "#6b7280",
    marginTop: 2,
  },

  reportInfo: {
    flexDirection: "column",
    alignItems: "flex-end",
  },

  reportTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#1e40af",
  },

  reportSubtitle: {
    fontSize: 10,
    color: "#6b7280",
    marginTop: 2,
  },

  // Executive Summary
  executiveSummary: {
    backgroundColor: "#eff6ff",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#3b82f6",
    borderRadius: 8,
    padding: 15,
    marginBottom: 20,
  },

  summaryTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#1e40af",
    marginBottom: 10,
    textAlign: "center",
  },

  summaryGrid: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginBottom: 10,
  },

  summaryItem: {
    alignItems: "center",
    flex: 1,
  },

  summaryNumber: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#dc2626",
  },

  summaryLabel: {
    fontSize: 8,
    color: "#6b7280",
    textAlign: "center",
    marginTop: 3,
  },

  conclusionBox: {
    backgroundColor: "#f8fafc",
    padding: 10,
    borderRadius: 4,
    marginTop: 15,
  },

  conclusionText: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
    textAlign: "center",
  },

  // Section styles
  section: {
    marginBottom: 15,
  },

  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: 8,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: "#e5e7eb",
  },

  // Grid layout
  grid: {
    flexDirection: "row",
    marginBottom: 15,
  },

  grid1: {
    flexDirection: "row",
    backgroundColor: "#eff6ff",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#3b82f6",
    borderRadius: 8,
    padding: 15,
    marginBottom: 20,
  },

  gridColumn: {
    flex: 1,
    marginRight: 10,
  },

  gridColumnLast: {
    flex: 1,
  },

  // Card styles
  card: {
    backgroundColor: "#f9fafb",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e5e7eb",
    borderRadius: 6,
    padding: 12,
    marginBottom: 10,
  },

  card1: {
    backgroundColor: "#f9fafb",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e5e7eb",
    borderRadius: 6,
    padding: 12,
    display: "grid",
    gap: "10px",
  },

  cardTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#374151",
    marginBottom: 8,
  },

  // Data row styles
  dataRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  dataRowNew: {
    marginBottom: 4,
    marginTop: 4,
    // backgroundColor: "#eff6ff",
    // borderWidth: 1,
    // borderStyle: "solid",
    // borderColor: "#3b82f6",

  },

  dataLabel: {
    fontSize: 9,
    color: "#1e40af",
    width: "40%",
    fontWeight: "bold",
  },

  dataLabelNew: {
    fontSize: 9,
    color: "#1e40af",
    width: "100%",
    fontWeight: "bold",
  },

  dataValue: {
    fontSize: 9,
    color: "#374151",
    width: "60%",
  },

  dataValueNew: {
    fontSize: 9,
    color: "#374151",
    width: "100%",
    paddingTop: "10px",
  },

  // Audit team styles
  auditTeam: {
    backgroundColor: "#eff6ff",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#3b82f6",
    borderRadius: 6,
    padding: 12,
    marginBottom: 15,
    breakInside: "avoid",
  },

  auditTeamTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
    marginBottom: 8,
    textAlign: "center",
  },

  teamRow: {
    flexDirection: "row",
    marginBottom: 4,
  },

  teamLabel: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#6b7280",
    width: "35%",
  },

  teamValue: {
    fontSize: 9,
    color: "#374151",
    width: "65%",
  },

  // Nonconformance styles
  nonconformanceHeader: {
    backgroundColor: "#1e40af",
    color: "white",
    padding: 15,
    marginBottom: 15,
    borderRadius: 5,
  },

  nonconformanceTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 3,
  },

  nonconformanceSubtitle: {
    fontSize: 12,
    opacity: 0.9,
  },

  nonconformanceItem: {
    backgroundColor: "rgb(204,255,0,.2)",
    borderLeftWidth: 4,
    borderLeftStyle: "solid",
    borderLeftColor: "rgb(204,255,0)",
    padding: 10,
    marginBottom: 8,
    borderRadius: 3,
  },

  critical: {
    backgroundColor: "rgb(245,14,2,0.2)",
    borderLeftWidth: 4,
    borderLeftStyle: "solid",
    borderLeftColor: "rgb(245,14,2)",
    padding: 10,
    marginBottom: 8,
    borderRadius: 3,
  },

  criticalRating: {
    fontSize: 9,
    backgroundColor: "rgb(245,14,2)",
    padding: 3,
    borderRadius: 2,
    color: "#ffffff",
  },

  major: {
    backgroundColor: "rgb(247,131,3,.2)",
    borderLeftWidth: 4,
    borderLeftStyle: "solid",
    borderLeftColor: "rgb(247,131,3)",
    padding: 10,
    marginBottom: 8,
    borderRadius: 3,
  },

  majorRating: {
    fontSize: 9,
    backgroundColor: "rgb(247,131,3)",
    padding: 3,
    borderRadius: 2,
    color: "#5D360C",
  },

  minor: {
    backgroundColor: "rgb(253,222,11,.2)",
    borderLeftWidth: 4,
    borderLeftStyle: "solid",
    borderLeftColor: "rgb(253,222,11)",
    padding: 10,
    marginBottom: 8,
    borderRadius: 3,
  },

  OpportunityforImprovement: {
    backgroundColor: "rgb(204,255,0,.2)",
    borderLeftWidth: 4,
    borderLeftStyle: "solid",
    borderLeftColor: "rgb(204,255,0)",
    padding: 10,
    marginBottom: 8,
    borderRadius: 3,
  },

  OpportunityforImprovementRating: {
    fontSize: 9,
    backgroundColor: "rgb(204,255,0)",
    padding: 3,
    borderRadius: 2,
    color: "green",
  },

  minorRating: {
    fontSize: 9,
    backgroundColor: "rgb(253,222,11)",
    padding: 3,
    borderRadius: 2,
    color: "#4D4408",
  },

  nonconformanceItemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },

  nonconformanceNumber: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#dc2626",
  },

  nonconformanceRating: {
    fontSize: 9,
    backgroundColor: "#fca5a5",
    padding: 3,
    borderRadius: 2,
    color: "#7f1d1d",
  },

  nonconformanceText: {
    fontSize: 9,
    color: "#374151",
    marginTop: 3,
    lineHeight: 1.4,
  },

  // Footer styles
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: "#e5e7eb",
  },

  footerText: {
    fontSize: 8,
    color: "#6b7280",
  },

  pageNumber: {
    fontSize: 8,
    color: "#6b7280",
  },

  protocolSection: {
    padding: 0,
  },

  protocolTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
    color: "#0000a0",
  },

  protocolCard: {
    marginBottom: 20,
    padding: 10,
    border: "1pt solid #ccc",
    borderRadius: 4,
  },

  protocolSectionTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 8,
    textTransform: "uppercase",
    color: "#333",
  },

  // New styles for tables
  tableContainer: {
    marginBottom: 20,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e5e7eb",
    borderRadius: 6,
    overflow: "hidden",
  },
  tableTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#ff8200",
    padding: 10,
    textAlign: "center",
    marginBottom: 0,
  },

  tableTitle2: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#0000a0",
    padding: 10,
    textAlign: "center",
    marginBottom: 6,
  },

  tableTitle1: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#0f766e",
    padding: 10,
    textAlign: "center",
    marginBottom: 6,
    borderRadius: 4,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f3f4f6",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: "#d1d5db",
  },
  headerCell: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#374151",
    flex: 1,
    textAlign: "center",
    padding: 8,
    borderRightWidth: 1,
    borderRightStyle: "solid",
    borderRightColor: "#d1d5db",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: "#e5e7eb",
  },
  tableRowAlternate: {
    flexDirection: "row",
    backgroundColor: "#f9fafb",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: "#e5e7eb",
  },
  cell: {
    fontSize: 9,
    color: "#374151",
    flex: 1,
    textAlign: "center",
    padding: 8,
    borderRightWidth: 1,
    borderRightStyle: "solid",
    borderRightColor: "#e5e7eb",
  },
  totalRow: {
    flexDirection: "column",
    marginTop: 15,
    paddingTop: 10,
    paddingBottom: 10,
    paddingHorizontal: 15,
    borderTopWidth: 2,
    borderTopStyle: "solid",
    borderTopColor: "#1e40af",
    backgroundColor: "#f8fafc",
    borderRadius: 4,
  },
  totalPointsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  conclusionRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: "#e5e7eb",
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
  },
  totalValue: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#1e40af",
    backgroundColor: "#eff6ff",
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#3b82f6",
  },
  conclusionLabel: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
  },
  conclusionValue: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#166534",
    backgroundColor: "#dcfce7",
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#bbf7d0",
  },
  previousYearHeader: {
    backgroundColor: "#f3f4f6",
    padding: 10,
    marginTop: 15,
    marginBottom: 10,
    borderRadius: 4,
  },
  previousYearTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#1e40af",
    textAlign: "center",
  },
});

const AuditPDFDocument = ({ data }) => {
  const auditData = data;
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getAuditConclusion = () => {
    const conclusion = auditData?.scoringDetails?.auditConclusion?.[0];
    const activeCategory = conclusion?.category?.find((cat) => cat.status);
    return activeCategory ? activeCategory.name : "Not Determined";
  };

  const getAuditConclusionStyle = () => {
    const conclusion = getAuditConclusion();

    switch (conclusion) {
      case "Compliant":
        return {
          color: "#166534",
          backgroundColor: "#dcfce7",
          borderColor: "#bbf7d0",
        };
      case "Needs Improvement":
      case "Gap Assessment":
        return {
          color: "#92400e",
          backgroundColor: "#fef3c7",
          borderColor: "#fcd34d",
        };
      case "At Risk":
        return {
          color: "#991b1b",
          backgroundColor: "#fee2e2",
          borderColor: "#fecaca",
        };
      default:
        return {
          color: "#374151",
          backgroundColor: "#f3f4f6",
          borderColor: "#d1d5db",
        };
    }
  };
  // Split data for better organization
  const auditDetails = auditData?.auditDetails?.AuditDetails || [];
  const unitDetails = auditData?.unitDetails?.unitDetails || [];

  // Split audit details into two columns
  const midPoint = Math.ceil(auditDetails.length / 2);
  const leftAuditDetails = auditDetails.slice(0, midPoint);
  const rightAuditDetails = auditDetails.slice(midPoint);

  // Split unit details into two columns
  const unitMidPoint = Math.ceil(unitDetails.length / 2);
  const leftUnitDetails = unitDetails.slice(0, unitMidPoint);
  const rightUnitDetails = unitDetails.slice(unitMidPoint);

  // Calculate total pages dynamically
  const marsNonconformances = auditData?.protocolDetails?.nonconformanceLog || [];
  const fsscNonconformances = auditData?.protocolDetails?.notCapturedFssc || [];

  // Estimate items per page (considering page size and item height)
  const itemsPerPage = 5;
  const marsPages = Math.ceil(marsNonconformances.length / itemsPerPage);
  const fsscPages = Math.ceil(fsscNonconformances.length / itemsPerPage);
  const totalPages = 1 + marsPages + fsscPages; // 1 for summary page

  const renderHeader = (pageNumber) => (
    <View style={styles.header}>
      <View style={styles.logoSection}>
        <Text style={styles.logoText}>MARS</Text>
        <Text style={styles.logoSubtext}>Quality Management System</Text>
      </View>
      <View style={styles.reportInfo}>
        <Text style={styles.reportTitle}>AUDIT REPORT</Text>
        <Text style={styles.reportSubtitle}>
          Audit #: {auditData.formId} | {formatDate(auditData.endDate)}
        </Text>
      </View>
    </View>
  );

  const renderFooter = (pageNumber) => (
    <View style={styles.footer}>
      <Text style={styles.footerText}>
        Mars Quality Management System - Confidential
      </Text>
      <Text style={styles.pageNumber}>
        {/* Page {pageNumber} of {totalPages} */}
        {auditData?.unitIndex}
      </Text>
    </View>
  );

  const renderDataRows = (items) => {
    if (!Array.isArray(items)) return [];
    return items.map((item, index) => (
      <View key={index} style={styles.dataRow}>
        <Text style={styles.dataLabel}>{item?.label || "N/A"}:</Text>
        <Text style={styles.dataValue}>
          {Array.isArray(item?.response)
            ? item.response.join(", ")
            : item?.response || item?.value || "N/A"}
        </Text>
      </View>
    ));
  };

  const renderNonconformancePages = (
    nonconformances,
    title,
    subtitle,
    startPageNum
  ) => {
    const pages = [];
    const itemsPerPage = 3;

    // Split nonconformances by isPreviousYear
    const currentYearNonconformances = nonconformances.filter(
      (nc) => nc.isPreviousYear === false
    );
    const previousYearNonconformances = nonconformances.filter(
      (nc) => nc.isPreviousYear === true
    );

    let currentPageNum = startPageNum;

    // Render Current Year Nonconformances
    if (currentYearNonconformances.length > 0) {
      for (
        let i = 0;
        i < currentYearNonconformances.length;
        i += itemsPerPage
      ) {
        const pageItems = currentYearNonconformances.slice(i, i + itemsPerPage);
        const pageNumber = currentPageNum + Math.floor(i / itemsPerPage);
        const isFirstPage = i === 0;
        const remainingSpace = itemsPerPage - pageItems.length;

        // Check if we can fit previous year items on this page
        const previousYearItemsForThisPage = previousYearNonconformances.slice(
          0,
          remainingSpace
        );
        const hasPreviousYearItems =
          previousYearItemsForThisPage.length > 0 && isFirstPage;

        pages.push(
          <Page
            key={`current-year-${pageNumber}`}
            size="A4"
            style={styles.page}
          >
            {renderHeader(pageNumber)}

            {isFirstPage && (
              <View style={styles.nonconformanceHeader}>
                <Text style={styles.nonconformanceTitle}>{title}</Text>
                <Text style={styles.nonconformanceSubtitle}>{subtitle}</Text>
              </View>
            )}

            <View style={styles.section}>
              {!isFirstPage && (
                <Text style={styles.sectionTitle}>{title} (Continued)</Text>
              )}

              {pageItems.map((nc, index) => {
                const rating = nc.nonconformityRating;
                const itemStyle =
                  rating === "Critical"
                    ? styles.critical
                    : rating === "Major"
                    ? styles.major
                    : rating === "Minor"
                    ? styles.minor
                    : rating === "Opportunity for Improvement (OFI)"
                    ? styles.OpportunityforImprovement
                    : styles.nonconformanceItem;

                const itemStyleRating =
                  rating === "Critical"
                    ? styles.criticalRating
                    : rating === "Major"
                    ? styles.majorRating
                    : rating === "Minor"
                    ? styles.minorRating
                    : rating === "Opportunity for Improvement (OFI)"
                    ? styles.OpportunityforImprovementRating
                    : styles.nonconformanceRating;

                return (
                  <View key={index} style={itemStyle}>
                    <View style={styles.nonconformanceItemHeader}>
                      <Text style={styles.nonconformanceNumber}>
                        {nc.number}
                      </Text>
                      <Text style={itemStyleRating}>{rating}</Text>
                    </View>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Details: </Text>
                      {nc.detailsOfNonconformity}
                    </Text>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Evidence: </Text>
                      {nc.evidenceOfNonconformity}
                    </Text>

                    {nc.RequirementReference && (
                      <Text style={styles.nonconformanceText}>
                        <Text style={{ fontWeight: "bold" }}>Reference: </Text>
                        {nc.RequirementReference}
                      </Text>
                    )}

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Status: </Text>
                      {nc.nonConformanceStatus}
                    </Text>
                    {auditDetails?.find(item => item.label === "Version")?.response !==1 && (
                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Correction: </Text>
                        {nc.evidenceOfCorrection || "N/A"}
                      </Text>
                    )}
                  </View>
                );
              })}

              {/* Add Previous Year section if there's space and it's the first page */}
              {hasPreviousYearItems && (
                <>
                  <View style={styles.previousYearHeader}>
                    <Text style={styles.previousYearTitle}>
                      Previous Year {title}
                    </Text>
                  </View>

                  {previousYearItemsForThisPage.map((nc, index) => {
                    const rating = nc.nonconformityRating;
                    const itemStyle =
                      rating === "Critical"
                        ? styles.critical
                        : rating === "Major"
                        ? styles.major
                        : rating === "Minor"
                        ? styles.minor
                        : rating === "Opportunity for Improvement (OFI)"
                        ? styles.OpportunityforImprovementRating
                        : styles.nonconformanceItem;

                    const itemStyleRating =
                      rating === "Critical"
                        ? styles.criticalRating
                        : rating === "Major"
                        ? styles.majorRating
                        : rating === "Minor"
                        ? styles.minorRating
                        : rating === "Opportunity for Improvement (OFI)"
                        ? styles.OpportunityforImprovementRating
                        : styles.nonconformanceRating;

                    return (
                      <View key={`prev-${index}`} style={itemStyle}>
                        <View style={styles.nonconformanceItemHeader}>
                          <Text style={styles.nonconformanceNumber}>
                            {nc.number}
                          </Text>
                          <Text style={itemStyleRating}>{rating}</Text>
                        </View>

                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Details: </Text>
                          {nc.detailsOfNonconformity}
                        </Text>

                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Evidence: </Text>
                          {nc.evidenceOfNonconformity}
                        </Text>

                        {nc.RequirementReference && (
                          <Text style={styles.nonconformanceText}>
                            <Text style={{ fontWeight: "bold" }}>
                              Reference:{" "}
                            </Text>
                            {nc.RequirementReference}
                          </Text>
                        )}

                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Status: </Text>
                          {nc.nonConformanceStatus}
                        </Text>
                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Correction: </Text>
                            {nc.evidenceOfCorrection || "N/A"}
                          </Text>
                       
                      </View>
                    );
                  })}
                </>
              )}
            </View>

            {renderFooter(pageNumber)}
          </Page>
        );
      }
      currentPageNum += Math.ceil(
        currentYearNonconformances.length / itemsPerPage
      );
    }

    // Render remaining Previous Year Nonconformances (if any didn't fit on first page)
    const remainingPreviousYearItems = previousYearNonconformances.slice(
      itemsPerPage - (currentYearNonconformances.length % itemsPerPage)
    );

    if (remainingPreviousYearItems.length > 0) {
      for (
        let i = 0;
        i < remainingPreviousYearItems.length;
        i += itemsPerPage
      ) {
        const pageItems = remainingPreviousYearItems.slice(i, i + itemsPerPage);
        const pageNumber = currentPageNum + Math.floor(i / itemsPerPage);
        const isFirstPage = i === 0;

        pages.push(
          <Page
            key={`previous-year-${pageNumber}`}
            size="A4"
            style={styles.page}
          >
            {renderHeader(pageNumber)}

            {isFirstPage && (
              <View style={styles.nonconformanceHeader}>
                <Text style={styles.nonconformanceTitle}>
                  Previous Year {title}
                </Text>
                <Text style={styles.nonconformanceSubtitle}>{subtitle}</Text>
              </View>
            )}

            <View style={styles.section}>
              {!isFirstPage && (
                <Text style={styles.sectionTitle}>
                  Previous Year {title} (Continued)
                </Text>
              )}

              {pageItems.map((nc, index) => {
                const rating = nc.nonconformityRating;
                const itemStyle =
                  rating === "Critical"
                    ? styles.critical
                    : rating === "Major"
                    ? styles.major
                    : rating === "Minor"
                    ? styles.minor
                    : styles.nonconformanceItem;

                const itemStyleRating =
                  rating === "Critical"
                    ? styles.criticalRating
                    : rating === "Major"
                    ? styles.majorRating
                    : rating === "Minor"
                    ? styles.minorRating
                    : styles.nonconformanceRating;

                return (
                  <View key={index} style={itemStyle}>
                    <View style={styles.nonconformanceItemHeader}>
                      <Text style={styles.nonconformanceNumber}>
                        {nc.number}
                      </Text>
                      <Text style={itemStyleRating}>{rating}</Text>
                    </View>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Details: </Text>
                      {nc.detailsOfNonconformity}
                    </Text>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Evidence: </Text>
                      {nc.evidenceOfNonconformity}
                    </Text>

                    {nc.RequirementReference && (
                      <Text style={styles.nonconformanceText}>
                        <Text style={{ fontWeight: "bold" }}>Reference: </Text>
                        {nc.RequirementReference}
                      </Text>
                    )}

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Status: </Text>
                      {nc.nonConformanceStatus}
                    </Text>
                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Correction: </Text>
                        {nc.evidenceOfCorrection || "N/A"}
                      </Text>
                   
                  </View>
                );
              })}
            </View>

            {renderFooter(pageNumber)}
          </Page>
        );
      }
    }

    return pages;
  };

  const renderFsscNonconformancePages = (
    nonconformances,
    title,
    subtitle,
    startPageNum
  ) => {
    const pages = [];
    const itemsPerPage = 3;

    // Split nonconformances by "Is Previous Year"
    const currentYearNonconformances = nonconformances.filter(nc => nc["Is Previous Year"] === false);
    const previousYearNonconformances = nonconformances.filter(nc => nc["Is Previous Year"] === true);

    let currentPageNum = startPageNum;

    // Render Current Year Nonconformances
    if (currentYearNonconformances.length > 0) {
      for (let i = 0; i < currentYearNonconformances.length; i += itemsPerPage) {
        const pageItems = currentYearNonconformances.slice(i, i + itemsPerPage);
        const pageNumber = currentPageNum + Math.floor(i / itemsPerPage);
        const isFirstPage = i === 0;
        const remainingSpace = itemsPerPage - pageItems.length;

        // Check if we can fit previous year items on this page
        const previousYearItemsForThisPage = previousYearNonconformances.slice(0, remainingSpace);
        const hasPreviousYearItems = previousYearItemsForThisPage.length > 0 && isFirstPage;

        pages.push(
          <Page
            key={`fssc-current-year-${pageNumber}`}
            size="A4"
            style={styles.page}
          >
            {renderHeader(pageNumber)}

            {isFirstPage && (
              <View style={styles.nonconformanceHeader}>
                <Text style={styles.nonconformanceTitle}>{title}</Text>
                <Text style={styles.nonconformanceSubtitle}>{subtitle}</Text>
              </View>
            )}

            <View style={styles.section}>
              {!isFirstPage && (
                <Text style={styles.sectionTitle}>{title} (Continued)</Text>
              )}

              {pageItems.map((nc, index) => {
                const rating = nc["Nonconformity Rating"];
                const itemStyle =
                  rating === "Critical"
                    ? styles.critical
                    : rating === "Major"
                    ? styles.major
                    : rating === "Minor"
                    ? styles.minor
                    : rating === "Opportunity for Improvement (OFI)"
                    ? styles.OpportunityforImprovement
                    : styles.nonconformanceItem;

                const itemStyleRating =
                  rating === "Critical"
                    ? styles.criticalRating
                    : rating === "Major"
                    ? styles.majorRating
                    : rating === "Minor"
                    ? styles.minorRating
                    : rating === "Opportunity for Improvement (OFI)"
                    ? styles.OpportunityforImprovementRating
                    : styles.nonconformanceRating;

                return (
                  <View key={index} style={itemStyle}>
                    <View style={styles.nonconformanceItemHeader}>
                      <Text style={styles.nonconformanceNumber}>
                        {nc["Number (#)"]}
                      </Text>
                      <Text style={itemStyleRating}>{rating}</Text>
                    </View>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Details: </Text>
                      {nc["Details of Nonconformity"]}
                    </Text>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Evidence: </Text>
                      {nc["Evidence of Non-conformity"]}
                    </Text>

                    {nc["Requirement Reference"] && (
                      <Text style={styles.nonconformanceText}>
                        <Text style={{ fontWeight: "bold" }}>Reference: </Text>
                        {nc["Requirement Reference"]}
                      </Text>
                    )}

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Status: </Text>
                      {nc["NonConformance Status"]}
                    </Text>
                    {auditDetails?.find(item => item.label === "Version")?.response !==1 && (
                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Evidence of Correction: </Text>
                        {nc["Evidence Of Correction"] || "N/A"}
                      </Text>
                    )}
                  </View>
                );
              })}

              {/* Add Previous Year section if there's space and it's the first page */}
              {hasPreviousYearItems && (
                <>
                  <View style={styles.previousYearHeader}>
                    <Text style={styles.previousYearTitle}>Previous Year {title}</Text>
                  </View>
                  
                  {previousYearItemsForThisPage.map((nc, index) => {
                    const rating = nc["Nonconformity Rating"];
                    const itemStyle =
                      rating === "Critical"
                        ? styles.critical
                        : rating === "Major"
                        ? styles.major
                        : rating === "Minor"
                        ? styles.minor
                        : rating === "Opportunity for Improvement (OFI)"
                        ? styles.OpportunityforImprovementRating
                        : styles.nonconformanceItem;

                    const itemStyleRating =
                      rating === "Critical"
                        ? styles.criticalRating
                        : rating === "Major"
                        ? styles.majorRating
                        : rating === "Minor"
                        ? styles.minorRating
                        : rating === "Opportunity for Improvement (OFI)"
                        ? styles.OpportunityforImprovementRating
                        : styles.nonconformanceRating;

                    return (
                      <View key={`fssc-prev-${index}`} style={itemStyle}>
                        <View style={styles.nonconformanceItemHeader}>
                          <Text style={styles.nonconformanceNumber}>
                            {nc["Number (#)"]}
                          </Text>
                          <Text style={itemStyleRating}>{rating}</Text>
                        </View>

                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Details: </Text>
                          {nc["Details of Nonconformity"]}
                        </Text>

                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Evidence: </Text>
                          {nc["Evidence of Non-conformity"]}
                        </Text>

                        {nc["Requirement Reference"] && (
                          <Text style={styles.nonconformanceText}>
                            <Text style={{ fontWeight: "bold" }}>Reference: </Text>
                            {nc["Requirement Reference"]}
                          </Text>
                        )}

                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Status: </Text>
                          {nc["NonConformance Status"]}
                        </Text>
                        <Text style={styles.nonconformanceText}>
                          <Text style={{ fontWeight: "bold" }}>Evidence of Correction: </Text>
                            {nc["Evidence Of Correction"] || "N/A"}
                          </Text>
                       
                      </View>
                    );
                  })}
                </>
              )}  
            </View>

            {renderFooter(pageNumber)}
          </Page>
        );
      }
      currentPageNum += Math.ceil(currentYearNonconformances.length / itemsPerPage);
    }

    // Render remaining Previous Year Nonconformances (if any didn't fit on first page)
    const remainingPreviousYearItems = previousYearNonconformances.slice(itemsPerPage - (currentYearNonconformances.length % itemsPerPage));
    
    if (remainingPreviousYearItems.length > 0) {
      for (let i = 0; i < remainingPreviousYearItems.length; i += itemsPerPage) {
        const pageItems = remainingPreviousYearItems.slice(i, i + itemsPerPage);
        const pageNumber = currentPageNum + Math.floor(i / itemsPerPage);
        const isFirstPage = i === 0;

        pages.push(
          <Page
            key={`fssc-previous-year-${pageNumber}`}
            size="A4"
            style={styles.page}
          >
            {renderHeader(pageNumber)}

            {isFirstPage && (
              <View style={styles.nonconformanceHeader}>
                <Text style={styles.nonconformanceTitle}>Previous Year {title}</Text>
                <Text style={styles.nonconformanceSubtitle}>{subtitle}</Text>
              </View>
            )}

            <View style={styles.section}>
              {!isFirstPage && (
                <Text style={styles.sectionTitle}>Previous Year {title} (Continued)</Text>
              )}

              {pageItems.map((nc, index) => {
                const rating = nc["Nonconformity Rating"];
                const itemStyle =
                  rating === "Critical"
                    ? styles.critical
                    : rating === "Major"
                    ? styles.major
                    : rating === "Minor"
                    ? styles.minor
                    : rating === "Opportunity for Improvement (OFI)"
                    ? styles.OpportunityforImprovementRating
                    : styles.nonconformanceItem;

                const itemStyleRating =
                  rating === "Critical"
                    ? styles.criticalRating
                    : rating === "Major"
                    ? styles.majorRating
                    : rating === "Minor"
                    ? styles.minorRating
                    : rating === "Opportunity for Improvement (OFI)"
                    ? styles.OpportunityforImprovementRating
                    : styles.nonconformanceRating;

                return (
                  <View key={index} style={itemStyle}>
                    <View style={styles.nonconformanceItemHeader}>
                      <Text style={styles.nonconformanceNumber}>
                        {nc["Number (#)"]}
                      </Text>
                      <Text style={itemStyleRating}>{rating}</Text>
                    </View>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Details: </Text>
                      {nc["Details of Nonconformity"]}
                    </Text>

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Evidence: </Text>
                      {nc["Evidence of Non-conformity"]}
                    </Text>

                    {nc["Requirement Reference"] && (
                      <Text style={styles.nonconformanceText}>
                        <Text style={{ fontWeight: "bold" }}>Reference: </Text>
                        {nc["Requirement Reference"]}
                      </Text>
                    )}

                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Status: </Text>
                      {nc["NonConformance Status"]}
                    </Text>
                    <Text style={styles.nonconformanceText}>
                      <Text style={{ fontWeight: "bold" }}>Evidence of Correction: </Text>
                        {nc["Evidence Of Correction"] || "N/A"}
                      </Text>
                    
                  </View>
                );
              })}
            </View>

            {renderFooter(pageNumber)}
          </Page>
        );
      }
    }

    return pages;
  };

  const renderProtocolPages = (protocolDetails) => {
    const sections = protocolDetails?.sections || [];
    const pageItems = [];
    let pageNumber = 1;

    sections.forEach((sectionName, sectionIndex) => {
      const sectionKey = sectionName?.toLowerCase();
      const sectionData = protocolDetails?.[sectionKey];

      // ✅ Skip sections that are undefined, null, or empty
      if (!Array.isArray(sectionData) || sectionData.length === 0) return;

      // ✅ Filter out questions that don't have valid content
      const validQuestions = sectionData.filter(
        (item) =>
          item?.label &&
          (item?.response?.length > 0 || item?.value || item?.response === 0)
      );

      if (validQuestions.length === 0) return; // Skip rendering this section if no valid questions

      pageItems.push(
        <Page key={sectionIndex} size="A4" style={styles.page} wrap>
          {renderHeader(pageNumber++)}

          <View style={styles.protocolSection}>
            <Text style={styles.protocolTitle}>Protocol Details</Text>

            <View style={styles.protocolCard} wrap={false}>
              <Text style={styles.protocolSectionTitle}>{sectionName}</Text>

              {validQuestions.map((item, i) => (
                <View key={i} style={styles.dataRowNew}>
                  <Text style={styles.dataLabelNew}>
                    Question: {item?.label || "N/A"}
                  </Text>
                  <Text style={styles.dataValueNew}>
                    Ans:{" "}
                    {Array.isArray(item?.response)
                      ? item.response.join(", ")
                      : item?.response ?? item?.value ?? "N/A"}
                  </Text>
                </View>
              ))}
            </View>
          </View>

          {renderFooter(pageNumber - 1)}
        </Page>
      );
    });

    return pageItems;
  };

  return (
    <Document>
      {/* Summary Page */}

      <Page size="A4" style={styles.page1}>
        <View
          style={{
            backgroundColor: "#0000a0",
            height: "100%",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* Background color block */}
          <View>
            {/* Centered Image */}
            <Image src={MarsLogo} style={{ width: 300, marginTop: 100 }} />
          </View>

          <View>
            {/* Centered Image */}
            <Text style={{ color: "white", fontSize: "24px" }}>
              {auditData?.unitIndex}
            </Text>
          </View>

          <View>
            {/* Centered Image */}

            <Text
              style={{
                color: "white",
                fontSize: "22px",
                textAlign: "center",
                paddingTop: "10px",
              }}
            >
              Audit # - {auditData?.formId}
            </Text>
          </View>

          <View>
            {/* Centered Image */}

            <Text
              style={{
                color: "white",
                fontSize: "22px",
                textAlign: "center",
                paddingTop: "10px",
              }}
            >
              Version -{" "}
              {auditData?.version === "V1"
                ? "1"
                : auditData?.version === "V2"
                ? "2"
                : "2"}
            </Text>
          </View>

          <View
            style={{
              backgroundColor: "#6CC9FF",
              height: 100,
              margin: 20,
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Centered Image */}
            <Text
              style={{
                color: "white",
                fontSize: "20px",
                margin: 10,
                alignContent: "center",
                alignItems: "center",
                textTransform: "capitalize",
              }}
            >
              MARS QMS {auditData?.auditType} Unit Audit
            </Text>
            <Text
              style={{
                color: "white",
                fontSize: "20px",
                margin: 5,
                alignContent: "center",
                alignItems: "center",
              }}
            >
              {formatDate(auditData?.endDate)}
            </Text>
          </View>

          <View>
            {/* Centered Image */}
            <Image src={MarsLogo1} style={{ width: 300, marginTop: 10 }} />
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        {renderHeader(1)}

        {/* Executive Summary */}
        <View style={styles.executiveSummary}>
          <Text style={styles.summaryTitle}>Executive Summary</Text>
          
          {/* QMS Results Table */}
          <View style={styles.tableContainer}>
            <Text style={styles.tableTitle}>QMS Results</Text>
            <View style={styles.tableHeader}>
              <Text style={styles.headerCell}>Category</Text>
              <Text style={styles.headerCell}>Number of Nonconformances</Text>
              <Text style={styles.headerCell}>Nonconformance Points</Text>
            </View>
            
            {(auditData.scoringDetails?.executiveSummaryResult || []).map((item, index) => (
              <View key={index} style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlternate}>
                <Text style={[styles.cell, { borderRightWidth: 1 }]}>{item.category}</Text>
                <Text style={[styles.cell, { borderRightWidth: 1 }]}>{item.noOfNonCon}</Text>
                <Text style={[styles.cell, { borderRightWidth: 0 }]}>{item.nonConPoints}</Text>
              </View>
            ))}
          </View>

          {/* FSSC Certification Results Table */}
          <View style={styles.tableContainer}>
            <Text style={styles.tableTitle}>FSSC Certification Results</Text>
            <View style={styles.tableHeader}>
              <Text style={styles.headerCell}>Category</Text>
              <Text style={styles.headerCell}>Number of Nonconformances</Text>
              <Text style={styles.headerCell}>Nonconformance Points</Text>
            </View>
            
            {(auditData.scoringDetails?.executiveSummaryCertification || []).map((item, index) => (
              <View key={index} style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlternate}>
                <Text style={[styles.cell, { borderRightWidth: 1 }]}>{item.category}</Text>
                <Text style={[styles.cell, { borderRightWidth: 1 }]}>{item.noOfNonCon}</Text>
                <Text style={[styles.cell, { borderRightWidth: 0 }]}>{item.nonConPoints}</Text>
              </View>
            ))}
          </View>

          {/* Total Nonconformance Points */}
          <View style={styles.totalRow}>
            <View style={styles.totalPointsRow}>
              <Text style={styles.totalLabel}>Total Nonconformance Points:</Text>
              <Text style={styles.totalValue}>
                {auditData?.scoringDetails?.executiveSummary?.find(
                  item => item?.category === "TotalNonconformancePoints"
                )?.number || "0"}
              </Text>
            </View>
            <View style={styles.conclusionRow}>
              <Text style={styles.conclusionLabel}>Audit Conclusion:</Text>
              <Text style={[styles.conclusionValue, getAuditConclusionStyle()]}>
                {getAuditConclusion()}
              </Text>
            </View>
          </View>
        </View>


        {renderFooter(1)}
      </Page>

    
      <Page size="A4" style={styles.page}>
        {/* Areas of Strength and Opportunity Table */}
        {renderHeader(1)}

        <View style={styles.executiveSummary}>
          <Text style={styles.tableTitle2}>
            Areas of Strength and Opportunity
          </Text>
          <View
            style={{
              // border: "1px solid black",
              width: "100%",
              marginBottom: 20,
            }}
          >
            {(auditData?.scoringDetails?.areaOfStrAndOps || []).map(
              (item, index) => (
                <View
                  key={index}
                  style={{
                    flexDirection: "row",
                    borderBottom:
                      index <
                      (auditData?.scoringDetails?.areaOfStrAndOps || [])
                        .length -
                        1
                        ? "none"
                        : "none",
                    minHeight: 40,
                  }}
                >
                  <View
                    style={{
                      width: "100%",
                      padding: 10,
                      justifyContent: "center",
                    }}
                  >
                    {item?.label && (
                      <Text
                        style={{
                          fontSize: 10,
                          fontWeight: "bold",
                          color: "#1e40af",
                          marginBottom: 3,
                        }}
                      >
                        {item.label}
                      </Text>
                    )}
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        color: "#1e40af",
                        lineHeight: 1.2,
                      }}
                    >
                      {item?.desL || "N/A"}
                    </Text>

                    <Text
                      style={{
                        fontSize: 8,
                        color: "#000",
                        marginTop: "10px",
                        lineHeight: 1.5,

                      }}
                    >
                      Ans: {item?.response || "N/A"}
                    </Text>
                  </View>
                  {/* <View
                    style={{
                      width: "30%",
                      padding: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      {item?.response || "0"}
                    </Text>
                  </View> */}
                </View>
              )
            )}
          </View>
        </View>
        {renderFooter(1)}
      </Page>

      <Page size="A4" style={styles.page}>
        {renderHeader(1)}

        {/* Unit Details Grid */}
        <View style={styles.grid1}>
          <View style={styles.gridColumn}>
            <Text style={styles.tableTitle2}>Unit Details</Text>
            <View style={styles.card1}>
              {renderDataRows(leftUnitDetails)}
              {renderDataRows(rightUnitDetails)}
            </View>
          </View>
        </View>

       

        {/* Audit Team */}
        <View style={styles.auditTeam}>
          <Text style={styles.auditTeamTitle}>Audit Team</Text>
          {(auditData?.auditDetails?.auditTeam || []).map((member, index) => (
            <View key={index} style={styles.teamRow}>
              <Text style={styles.teamLabel}>{member?.label || "N/A"}:</Text>
              <Text style={styles.teamValue}>
                {typeof member?.response === "object"
                  ? Object.entries(member.response)
                      .map(([key, value]) => `${key}: ${value}`)
                      .join(", ")
                  : member?.response || "N/A"}
              </Text>
            </View>
          ))}
        </View>

        {renderFooter(1)}
      </Page>

      {/* Mars QMS Nonconformances Pages */}
      {marsNonconformances.length > 0 &&
        renderNonconformancePages(
          marsNonconformances,
          "Nonconformances & Opportunities",
          "Quality Management System Findings",
          2
        )}

      {/* FSSC 22000 Nonconformances Pages */}
      {fsscNonconformances.length > 0 &&
        renderFsscNonconformancePages(
          fsscNonconformances,
          "FSSC 22000 Nonconformances",
          "Food Safety System Certification Findings",
          2 + marsPages
        )}

      {/* Protocol Pages */}
      {/* {auditData.protocolDetails?.data?.sections?.length > 0 &&
        renderProtocolPages(auditData.protocolDetails?.data)} */}

      {/* Final Page */}
      <Page size="A4" style={styles.page}>
        {renderHeader(1)}
        <View style={styles.section}>
          {/* Conformance Level Determination */}
          <View style={{ marginBottom: 20 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                marginBottom: 10,
                backgroundColor: "#04047E",
                height: "80px",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "50%",
                  color: "white",
                  textTransform: "uppercase",
                  padding: 15,
                }}
              >
                Conformance Level Determination
              </Text>
              <View
                style={{
                  width: "50%",
                  backgroundColor: "#060648",
                  height: "100%",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "100%",
                    color: "white",
                    padding: 20,
                  }}
                >
                  See Mars QMS Second Party Audit Procedure for full list of
                  criteria and thresholds
                </Text>
              </View>
            </View>

            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Header Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                  color: "white",
                  borderBottom: "1px solid black",
                }}
              >
                <Text
                  style={{
                    width: "50%",
                    fontSize: 8,
                    padding: 8,
                    textAlign: "center",
                    fontWeight: "bold",
                    borderRight: "1px solid black",
                  }}
                >
                  Conformance Level
                </Text>
                <Text
                  style={{
                    width: "50%",
                    fontSize: 8,
                    padding: 8,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Nonconformance Points
                </Text>
              </View>

              {/* Compliant Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#c5e17a",
                  borderBottom: "1px solid black",
                  minHeight: 30,
                }}
              >
                {/* First cell with COMPLIANT */}
                <View
                  style={{
                    width: "50%",
                    borderRight: "1px solid black",
                    justifyContent: "center", // vertical center
                    alignItems: "center", // horizontal center
                  }}
                >
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    COMPLIANT
                  </Text>
                </View>

                {/* FACTORIES cell */}
                <View style={{ width: "25%", borderRight: "1px solid black" }}>
                  <Text
                    style={{
                      backgroundColor: "#060648",
                      color: "white",
                      fontSize: 6,
                      padding: 4,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    FACTORIES
                  </Text>
                  <Text
                    style={{
                      fontSize: 7,
                      padding: 8,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#0000a0",
                    }}
                  >
                    {"<="} 34
                  </Text>
                </View>

                {/* OTHER UNITS cell */}
                <View style={{ width: "25%" }}>
                  <Text
                    style={{
                      backgroundColor: "#060648",
                      color: "white",
                      fontSize: 6,
                      padding: 4,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    OTHER UNITS
                  </Text>
                  <Text
                    style={{
                      fontSize: 7,
                      padding: 8,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#0000a0",
                    }}
                  >
                    {"<="} 18
                  </Text>
                </View>
              </View>

              {/* Needs Improvement Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#e84b3c",
                  borderBottom: "1px solid black",
                  minHeight: 30,
                }}
              >
                {/* First cell */}
                <View
                  style={{
                    width: "50%",
                    borderRight: "1px solid black",
                    justifyContent: "center", // vertical
                    alignItems: "center", // horizontal
                  }}
                >
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    NEEDS IMPROVEMENT
                  </Text>
                </View>

                {/* FACTORIES */}
                <View style={{ width: "25%", borderRight: "1px solid black" }}>
                  <Text
                    style={{
                      backgroundColor: "#060648",
                      color: "white",
                      fontSize: 6,
                      padding: 4,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    FACTORIES
                  </Text>
                  <Text
                    style={{
                      fontSize: 7,
                      padding: 8,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#0000a0",
                    }}
                  >
                    {">="} 35
                  </Text>
                </View>

                {/* OTHER UNITS */}
                <View style={{ width: "25%" }}>
                  <Text
                    style={{
                      backgroundColor: "#060648",
                      color: "white",
                      fontSize: 6,
                      padding: 4,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    OTHER UNITS
                  </Text>
                  <Text
                    style={{
                      fontSize: 7,
                      padding: 8,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#0000a0",
                    }}
                  >
                    {">="} 19
                  </Text>
                </View>
              </View>

              {/* At Risk Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#f8ce6a",
                  borderBottom: "1px solid black",
                  minHeight: 30,
                }}
              >
                {/* First cell */}
                <View
                  style={{
                    width: "50%",
                    borderRight: "1px solid black",
                    justifyContent: "center", // vertical
                    alignItems: "center", // horizontal
                  }}
                >
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    AT RISK
                  </Text>
                </View>

                {/* FACTORIES */}
                <View style={{ width: "25%", borderRight: "1px solid black" }}>
                  <Text
                    style={{
                      backgroundColor: "#060648",
                      color: "white",
                      fontSize: 6,
                      padding: 4,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    FACTORIES
                  </Text>
                  <Text
                    style={{
                      fontSize: 7,
                      padding: 8,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#0000a0",
                    }}
                  >
                    {">="} 40
                  </Text>
                </View>

                {/* OTHER UNITS */}
                <View style={{ width: "25%" }}>
                  <Text
                    style={{
                      backgroundColor: "#060648",
                      color: "white",
                      fontSize: 6,
                      padding: 4,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    OTHER UNITS
                  </Text>
                  <Text
                    style={{
                      fontSize: 7,
                      padding: 8,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#0000a0",
                    }}
                  >
                    {">="} 22
                  </Text>
                </View>
              </View>

            </View>
          </View>

          {/* Required Action Post Audit */}
          <View style={{ marginBottom: 20 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                marginBottom: 10,
                backgroundColor: "#04047E",
                height: "80px",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "50%",
                  color: "white",
                  textTransform: "uppercase",
                  padding: 15,
                }}
              >
                Required Action Post Audit
              </Text>
              <View
                style={{
                  width: "50%",
                  backgroundColor: "#060648",
                  height: "100%",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "100%",
                    color: "white",
                    padding: 20,
                  }}
                >
                  See Mars QMS Second Party Audit Procedure for full list of
                  criteria and thresholds
                </Text>
              </View>
            </View>

            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Header Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                  color: "white",
                  borderBottom: "1px solid black",
                }}
              >
                <Text
                  style={{
                    width: "50%",
                    fontSize: 8,
                    padding: 8,
                    textAlign: "center",
                    fontWeight: "bold",
                    borderRight: "1px solid black",
                    textTransform: "uppercase",
                  }}
                >
                  Conformance Level
                </Text>
                <Text
                  style={{
                    width: "50%",
                    fontSize: 8,
                    padding: 8,
                    textAlign: "center",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  Required Actions
                </Text>
              </View>

              {/* Compliant Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#c5e17a",
                  borderBottom: "1px solid black",
                  minHeight: 30,
                }}
              >
                <View
                  style={{
                    width: "50%",
                    borderRight: "1px solid black",
                    color: "#155724",
                    justifyContent: "center", // vertical center
                    alignItems: "center", // horizontal center
                  }}
                >
                   <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    COMPLIANT
                  </Text>
                </View>
                <View
                  style={{
                    width: "50%",
                    padding: 8,
                    backgroundColor: "#c5e17a",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      Action all nonconformities and continue to sustain/improve
                      performance.
                    </Text>
                  </View>
                </View>
              </View>

              {/* Needs Improvement Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#e84b3c",
                  borderBottom: "1px solid black",
                  minHeight: 30,
                }}
              >
                <View
                  style={{
                    width: "50%",
                    borderRight: "1px solid black",
                    justifyContent: "center", // vertical
                    alignItems: "center", // horizontal

                  }}
                >
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    NEEDS IMPROVEMENT
                  </Text>
                </View>
                <View
                  style={{
                    width: "50%",
                    padding: 8,
                    backgroundColor: "#e84b3c",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      All Major Nonconformities will have a review within 28
                      days by 2nd party along with a completed Correction and a
                      Corrective Action Plan in place.
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      The units plan to return to Compliance is to be reviewed
                      at the Parent Unit Quality Management Review.
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      For units that received 1 Major Nonconformity and a
                      nonconformance score below 35, they can return to
                      Compliant Level in the same year.
                    </Text>
                  </View>
                </View>
              </View>

              {/* At Risk Row */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#f8ce6a",
                  borderBottom: "1px solid black",
                  minHeight: 30,
                }}
              >
                <View
                  style={{
                    width: "50%",
                    borderRight: "1px solid black",
                    justifyContent: "center", // vertical
                    alignItems: "center", // horizontal
                  }}
                >
                      <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    AT RISK
                  </Text>
                </View>
                <View
                  style={{
                    width: "50%",
                    padding: 8,
                    backgroundColor: "#f8ce6a",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      Concession is required to continue production and/or
                      services.
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      Unit must undergo full scope audits every 6 months until
                      achieving 3 consecutive QMS compliant results from the
                      initial audit. The unit's At-Risk level of conformance
                      will remain until the completion of their first 6-month
                      audit. The unit's level of conformance will be indicated
                      by the results of each 6-month audit.
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      All Major and/or Critical Nonconformities must have a
                      review within 28 days by a 2nd party with a completed
                      Correction and a Corrective Action Plan in place.
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    >
                      •
                    </Text>
                    <Text
                      style={{
                        fontSize: 7,
                        flex: 1,
                        color: "#000",
                        lineHeight: 1.2,
                      }}
                    >
                      The units plan to return to Compliance is to be reviewed
                      at the Mars Inc. Quality Management Review.
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
        {renderFooter(1)}
      </Page>
    </Document>
  );
};

export default AuditPDFDocument;
